import Vue from "vue";
import Vuetify, {VIcon, VTextField} from "vuetify/lib";
import "vuetify/src/stylus/app.styl";
import pt from 'vuetify/es5/locale/pt'
import currency from "v-currency-field";
import 'v-currency-field/dist/index.css'

Vue.use(Vuetify, {
    iconfont: "md",
    theme: {
        primary: "#2c004b"
    },
    lang: {
        locales: {pt},
        current: "pt"
    },
    components: {VIcon, VTextField}
});

Vue.use(currency);
